import {config} from "../../../utility/swaggerClient";
import Dropzone from 'react-dropzone-uploader';
import React, {useState} from "react";
import ModalExample from "../PopupWindow";
import Spinner from "../../views/Snowflake/as/Spinner";

let openModal =()=>{};
let uploader ={};

const MyUploader = (prj,username,uploadType,type,parentproject,customerid,content,setcontent,setDisableUploadBack,
  setPrjName,checkuploadinlist,disableUploadBack,disableupload,setDisableupload,setDisabledownload) => {

  console.log(`customerid: ${customerid}`);
  console.log(prj);
  // specify upload params and url for your files
  const p = parentproject == null ? "" : parentproject;
  const getUploadParams = ({ meta }) => (

      {
        //url: `${config.protocol}://${config.host}/api/shift/uploadFile/${prj}`,
        url: `${config.protocol}://${config.host}/api/fuse/uploadtest/${prj}/`,
        headers:{"Authorization": sessionStorage.getItem('jwt')},
        fields:  {parentproject: p, type, customerid, operation: uploadType}
      }

  );

  // called every time a file's `status` changes
  const handleChangeStatus = ({ meta, file,xhr,remove }, status) => {
    // console.log(status, meta, file);
    if(status === 'preparing'){
      if(type === 'customer' && uploadType === 'upload' && status === 'preparing'){
        setPrjName(file.name.replace('.zip',''));
      }
      if(uploader.files.length >1){
        uploader.files.shift();
      }
      setDisableUploadBack(true);
    }

    if(status === 'error_upload'){
      console.log("upload file failed");
      xhr.onreadystatechange = function() {
        if (this.readyState === 4 && this.status !== 200) {
          console.log("uplaod failed ")

          setcontent(JSON.parse(xhr.response).msg);
          openModal();
        }
      };
      xhr.onerror= function(e) {
        console.log("uplaod api call failed ")
        //setcontent("Zip file is too large, please contact your administrator. ");
        setcontent("Error in uploading, please contact your administrator. ");
        openModal();
      };
      setDisableUploadBack(false);
    }
    if(status === 'done'){
      let flag = false;
      if(uploadType === 'upload'){
        (function ensureFooIsSet() {
          return new Promise(((resolve, reject) => {
            (function waitForFoo(){
              flag = checkuploadinlist(prj,type);
              if (flag)
                setDisableupload(true);
                return resolve(setDisableUploadBack(false));
              setTimeout(waitForFoo, 3000);
            })();
          }));
        })();
      }else{
        setDisableUploadBack(false);
      }
      setDisabledownload(false)
    }

  };

  // receives array of files that are done uploading when submit button is clicked
  const handleSubmit = (files, allFiles) => {
    // console.log(files.map(f => f.meta));
    // allFiles.forEach(f => f.remove());
    // setDisableUploadBack(true);
  };

  return (
    <div>
      <ModalExample
        hasTitle
        warning
        className="modal_sm"
        setClick={click => openModal = click}
        content={content}
      />

      <Dropzone
        ref={ref => uploader = ref}
        onChangeStatus={handleChangeStatus}
        getUploadParams={getUploadParams}

        // onSubmit={handleSubmit}
        //accept=".sql"
        accept=".zip"
        disabled = {disableupload}
      />
      {disableUploadBack && (
        <div>
          <Spinner />
        </div>
      )}
    </div>
  );
};

export default MyUploader;



// WEBPACK FOOTER //
// ./src/components/elements/UploadUnitest/index.js